var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-checkbox-group',{attrs:{"options":_vm.options,"name":"select-tipos-instituicoes","stacked":""},model:{value:(_vm.local_value),callback:function ($$v) {_vm.local_value=$$v},expression:"local_value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }